export default "__VITE_ASSET__fc6fa5a1__"